import { render, staticRenderFns } from "./_jdbGtf.vue?vue&type=template&id=3b3536d2&lang=pug&"
import script from "./_jdbGtf.vue?vue&type=script&lang=js&"
export * from "./_jdbGtf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports